/* FÉNIX R07.86 — mobile interaction authority · catalog expand repair */
(function(){'use strict';
  function coarse(){
    return window.matchMedia('(max-width:760px)').matches ||
      (window.matchMedia('(max-width:1180px)').matches && window.matchMedia('(hover:none) and (pointer:coarse)').matches);
  }

  function isCollection(){
    return !!(document.body && document.body.classList.contains('template-collection'));
  }

  function prepareProductControls(){
    if(!coarse() || !isCollection()) return;
    document.querySelectorAll('.fnx43-expand').forEach(function(btn){
      var pressed=btn.getAttribute('aria-pressed')==='true';
      btn.setAttribute('aria-label',pressed?'Reducir producto':'Ampliar producto');
      btn.setAttribute('title',pressed?'Reducir':'Ampliar');
      btn.removeAttribute('data-fnx85-mobile-view');
      btn.style.pointerEvents='auto';
      btn.style.zIndex='30';
    });
  }

  function toggleCatalogCard(button){
    var item=button && button.closest ? button.closest('.grid__item') : null;
    var container=item && item.parentElement;
    if(!item || !container) return false;
    var cards=[].slice.call(container.querySelectorAll(':scope > .grid__item'));
    if(!cards.length) cards=[].slice.call(document.querySelectorAll('body.template-collection .grid-link__container>.grid__item'));
    var expanding=!item.classList.contains('is-fnx43-featured');

    cards.forEach(function(other){
      other.classList.remove('is-fnx43-featured');
      var otherButton=other.querySelector('.fnx43-expand');
      if(otherButton){
        otherButton.setAttribute('aria-pressed','false');
        otherButton.setAttribute('aria-label','Ampliar producto');
        otherButton.setAttribute('title','Ampliar');
        var otherLabel=otherButton.querySelector('span');
        if(otherLabel) otherLabel.textContent='Ampliar';
      }
    });

    if(expanding){
      item.classList.add('is-fnx43-featured');
      button.setAttribute('aria-pressed','true');
      button.setAttribute('aria-label','Reducir producto');
      button.setAttribute('title','Reducir');
      var label=button.querySelector('span');
      if(label) label.textContent='Reducir';
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        window.setTimeout(function(){
          try{ item.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(_){ item.scrollIntoView(); }
        },30);
      }
    }
    return true;
  }

  /* R07.86: en móvil la lupa vuelve a hacer lo que fue diseñada para hacer:
     ampliar/reducir la tarjeta. Se resuelve aquí en capture para evitar carreras
     con enlaces estirados o con el listener desktop de v43. */
  document.addEventListener('click',function(event){
    if(!coarse() || !isCollection()) return;
    var target=event.target && event.target.closest ? event.target.closest('.fnx43-expand') : null;
    if(!target) return;
    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation) event.stopImmediatePropagation();
    toggleCatalogCard(target);
  },true);

  /* Hardening de la lupa del header: v24 conserva la experiencia predictiva;
     solo si un toque que debía abrirla no produce estado abierto, cae a /search. */
  document.addEventListener('click',function(event){
    if(!coarse()) return;
    var trigger=event.target && event.target.closest ? event.target.closest('.nm-mobile-search-toggle,[data-nm-search-trigger]') : null;
    if(!trigger) return;
    var wasOpen=trigger.getAttribute('aria-expanded')==='true';
    if(wasOpen) return;
    window.setTimeout(function(){
      var panel=document.getElementById('nmSearchPanel');
      var opened=trigger.getAttribute('aria-expanded')==='true' || (panel && panel.getAttribute('aria-hidden')==='false');
      if(!opened) window.location.assign('/search');
    },180);
  },true);

  function init(){
    prepareProductControls();
    var root=document.querySelector('body.template-collection .grid-link__container');
    if(root && window.MutationObserver){
      new MutationObserver(function(){prepareProductControls();}).observe(root,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('pageshow',prepareProductControls);
})();